/* 
 *  This file hrone-avatar.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2024  
 *  (C) 2015-2024. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *  
 */

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HroneAvatarService {
  
  colorCodes = ['#02563D','#FF674D','#23A578','#5A3C66','#665830','#664A36','#21365B','#8A3FFC','#E196FF','#344966', '#A53860', '#450920','#016FB9','#D63230','#99AA38','#F90093','#335145','#C16200','#968E85','#A52422'];
  userColorCode = new Map()
  
  setColor(name:string){
     if(!this.userColorCode.size) this.userColorCode.set(name,this.colorCodes[0])
     else if(this.userColorCode.size && !this.userColorCode.has(name)){
     const arr = Array.from(this.userColorCode.values())
     const ind = this.colorCodes?.findIndex(item => item === arr[arr?.length-1]);
     if(ind < (this.colorCodes.length-1)) this.userColorCode.set(name,this.colorCodes[ind+1])
     else this.userColorCode.set(name,this.colorCodes[0])
     } 
  }
}
